import { useTheme } from 'next-themes';
import { type ReactNode } from 'react';

import { CollaborationCursors } from './collaboration-cursors';
import { DesktopNavbar } from './desktop-navbar';
import { DotGridCanvas } from './dot-grid-canvas';
import * as styles from './index.css';
import { MobileNavbar } from './mobile-navbar';

export const AffineOtherPageLayout = ({
  children,
  showNavigation = true,
  showCollaborationCursors = true,
}: {
  children: ReactNode;
  showNavigation?: boolean;
  showCollaborationCursors?: boolean;
}) => {
  const { resolvedTheme } = useTheme();

  return (
    <div className={styles.root}>
      <DotGridCanvas dark={resolvedTheme === 'dark'} />
      {showCollaborationCursors ? <CollaborationCursors /> : null}
      {showNavigation && BUILD_CONFIG.isElectron ? (
        <div className={styles.draggableHeader} />
      ) : showNavigation ? (
        <div className={styles.topNav}>
          <DesktopNavbar />
          <MobileNavbar />
        </div>
      ) : null}

      {children}
    </div>
  );
};
